import { all, takeEvery, put, call, select } from 'redux-saga/effects'
import {
    VALIDATE_SETUP_PROJECT,
    VALIDATE_SETUP_CHANNELS,
    VALIDATE_CHOOSE_PLUGIN,
    VALIDATE_PLUGIN,
    WEBSITE_CUSTOM,
    WEBSITE_WORDPRESS
} from './constants'
import { message } from 'antd'
import { setCurrentAppId } from '../Ekko/actions'
import { nextStep, setWebsiteType } from './actions'
import { setCurrentApplication } from '../Ekko/actions'

import AppsClient from '../../apiClient/AppsClient'
import RoomsClient from '../../apiClient/RoomsClient'
const appsClient = new AppsClient()
const roomsClient = new RoomsClient()

function* validateSetupProject() {
    const { onboarding } = yield select()
    const { websiteUrl, projectName } = onboarding

    if (!websiteUrl || websiteUrl == '') {
        message.error('Invalid website Url')
    } else if (!projectName || projectName == '') {
        message.error('Invalid Project Name')
    } else {
        yield put(nextStep())
    }
}

function* validateSetupChannels() {
    const { onboarding } = yield select()
    const { projectName, websiteUrl, channels } = onboarding

    if (!channels || channels.length < 1) {
        message.error('You must have at least one topic to continue !')
    } else if (channels.length > 5) {
        message.error('You cannot have more than 5 topics !')
    } else {
        try {
            const { id } = yield call(appsClient.create, { name: projectName })
            yield put(setCurrentAppId(id))
            const application = yield call(appsClient.update, { params: { website_url: websiteUrl, product: 'now' } })
            yield put(setCurrentApplication({ application }))

            yield all(channels.map(channel => call(roomsClient.postChannel, { room_id: channel.name })))

            message.success('Project created successfully !')
            yield put(nextStep())
        } catch (e) {
            console.warn(e)
            message.error('Failed to create project... Retry later or contact support.')
        }
    }
}

function* validateChoosePlugin({ payload: { plugin } }) {
    if ([WEBSITE_WORDPRESS, WEBSITE_CUSTOM].includes(plugin)) {
        yield put(setWebsiteType(plugin))
        yield put(nextStep())
    } else {
        message.error('Error occured while choosing plugin.')
    }
}

function* validatePluginInstall() {
    // can check install here ?
    yield put(nextStep())
}

export default function* appSagas() {
    yield all([
        takeEvery(VALIDATE_SETUP_PROJECT, validateSetupProject),
        takeEvery(VALIDATE_SETUP_CHANNELS, validateSetupChannels),
        takeEvery(VALIDATE_CHOOSE_PLUGIN, validateChoosePlugin),
        takeEvery(VALIDATE_PLUGIN, validatePluginInstall)
    ])
}
